import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Validators } from "@angular/forms";
import { ColDef } from "ag-grid-community";
import * as _ from "lodash";
import { LangUtils } from "../../../../edtell-portal/namespaces/lang-utils.namespace";
import { EdtellFormControl } from "../../../../srs-forms/classes/edtell-form-control";
import { EdtellFormGroup } from "../../../../srs-forms/classes/edtell-form-group.class";
import { SrsCheckboxComponent } from "../../../../srs-forms/components/elements/srs-checkbox/srs-checkbox.component";
import { SrsFormFieldComponent } from "../../../../srs-forms/components/elements/srs-form-field/srs-form-field.component";
import { SrsSelectBoxComponent } from "../../../../srs-forms/components/elements/srs-select-box/srs-select-box.component";
import { SrsFormState } from "../../../../srs-forms/enumerations/form-state.enum";
import { SrsCheckboxConfig } from "../../../../srs-forms/interfaces/elements/srs-checkbox-config.interface";
import { SrsFormFieldConfig } from "../../../../srs-forms/interfaces/elements/srs-form-field-config.interface";
import { SrsSelectBoxConfig } from "../../../../srs-forms/interfaces/elements/srs-select-box-config.interface";
import { SrsMultiElementWidgetConfig } from "../../../../srs-forms/interfaces/widgets/srs-multi-element-widget-config";
import { IWebhookLog } from "../../../interfaces/webhook-log.interface";
import { IProcessedWebhook } from "../../../interfaces/webhook.interface";
import { WebhookFormComponentConfig } from "../../../interfaces/webhooks-component-config.interface";

@Component({
  selector: "app-processed-webhook-form",
  templateUrl: "./processed-webhook-form.component.html",
  styleUrls: ["./processed-webhook-form.component.scss"],
})
export class ProcessedWebhookFormComponent implements OnInit {
  @Output()
  onSave = new EventEmitter<IProcessedWebhook>();

  @Output()
  onCancel = new EventEmitter<void>();

  @Input()
  config: WebhookFormComponentConfig;

  formConfig: SrsMultiElementWidgetConfig;
  formGroup: EdtellFormGroup;

  isAdd = true;
  loaded = false;

  webhook: IProcessedWebhook = {
    enabled: true,
  } as IProcessedWebhook;

  constructor() {}

  async ngOnInit() {
    if (this.config.editId != null) {
      this.webhook = await this.config.api.webhooks.getWebhook(
        this.config.editId,
      );
      this.isAdd = false;
    }

    this.formGroup = new EdtellFormGroup(SrsFormState.WRITE, {
      name: new EdtellFormControl(this.webhook.name, [Validators.required]),
      endpoint: new EdtellFormControl(this.webhook.endpoint, [
        Validators.required,
      ]),
      authToken: new EdtellFormControl(this.webhook.authToken, [
        Validators.required,
      ]),
      enabled: new EdtellFormControl(this.webhook.enabled),
    });

    this.formConfig = {
      formGroup: this.formGroup,
      elements: [
        [
          {
            component: SrsFormFieldComponent,
            config: LangUtils.type<SrsFormFieldConfig>({
              key: "name",
              size: 6,
              title: "Name",
            }),
          },
          {
            component: SrsCheckboxComponent,
            config: LangUtils.type<SrsCheckboxConfig>({
              key: "enabled",
              size: 2,
              title: "Enabled",
            }),
          },
        ],
        [
          {
            component: SrsFormFieldComponent,
            config: LangUtils.type<SrsFormFieldConfig>({
              key: "endpoint",
              size: 12,
              title: "Endpoint",
            }),
          },
        ],
        [
          {
            component: SrsFormFieldComponent,
            config: LangUtils.type<SrsFormFieldConfig>({
              key: "authToken",
              size: 12,
              title: "Authentication Token",
            }),
          },
        ],
      ],
    };

    if (this.config.apiKeys != null) {
      this.formGroup.addControl(
        "apiKeyId",
        new EdtellFormControl(this.webhook.apiKeyId, [Validators.required]),
      );
      const rowOne = this.formConfig.elements[0];
      this.formConfig.elements[0] = [
        rowOne[0],
        {
          component: SrsSelectBoxComponent,
          config: LangUtils.type<SrsSelectBoxConfig<number>>({
            key: "apiKeyId",
            title: "Api Key",
            size: 4,
            options: this.config.apiKeys,
          }),
        },
        rowOne[1],
      ];
    }

    this.loaded = true;
  }

  async save() {
    if (this.formGroup.valid) {
      _.merge(this.webhook, this.formGroup.value);
      const result = await this.config.api.webhooks.saveWebhook(this.webhook);
      this.onSave.emit(result);
      // navigate away
    }
  }

  async cancel() {
    this.onCancel.emit();
  }

  async delete() {
    await this.config.api.webhooks.deleteWebhook(this.config.editId);
    this.onCancel.emit();
  }
}
